import React, { Component } from 'react';

import { Offcanvas, Row, Col, Card } from 'react-bootstrap';

import CommonButton from '../components/CommonButton';
import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonFile from '../components/CommonFile';

/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
import CustomDatePicker from "../components/CommonDatePicker";
*/

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import SimpleBar from 'simplebar-react';
class InputUserDataUser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: new Date(),
            changePassword: false,
        };
    }
    
    handleDateChange = (date) => {
        this.setState({ selectedDate: date });
    }
    
    componentDidUpdate = async (prevProps) => {
        if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
            await this.prepareInputs();
        }
    }
    
    prepareInputs = async () => {
        const { Action, Inputs, onUpdateState } = this.props;
        const isUpdateMode = Action.Mode === 'update';
    
        const updatedInputs = fn.setRequiredPrimaryKey(
            this.initNewPassword(Inputs, false),
            isUpdateMode
        );
    
        this.setState({ changePassword: false }, () => {
            onUpdateState('Inputs', updatedInputs);
        });
    }
    
    toggleChangePassword = () => {
        const { Inputs, onUpdateState } = this.props;
    
        this.setState(
            prevState => ({ changePassword: !prevState.changePassword }),
            () => {
                const updatedInputs = this.initNewPassword(Inputs, this.state.changePassword);
                onUpdateState('Inputs', updatedInputs);
            }
        );
    }
    
    initNewPassword = (Inputs, isRequired) => {
        return {
            ...Inputs,
            new_password: {
                ...Inputs.new_password,
                value: '',
                validator: {
                    ...Inputs.new_password.validator,
                    required: isRequired
                },
                error: {
                    ...Inputs.new_password.error,
                    status: null
                }
            }
        };
    }

    toggleUserTypes = (index) => {
        const { Inputs, onUpdateState } = this.props;

        const getUpdatedField = (fieldKey, { value, required }) => ({
            ...Inputs[fieldKey],
            value: value !== undefined ? value : Inputs[fieldKey].value,
            validator: {
                ...Inputs[fieldKey].validator,
                required: required !== undefined ? required : Inputs[fieldKey].validator.required,
            },
            error: {
                ...Inputs[fieldKey].error,
                status: null,
                msg: '',
            }
        });

        const fieldUpdatesByIndex = {
            '0': {
                academy_id: { value: '', required: false },
                enterprise_id: { value: '', required: false }
            },
            '1': {
                academy_id: { value: '', required: false },
                enterprise_id: { value: '', required: false }
            },
            '2': {
                academy_id: { required: true },
                enterprise_id: { value: '', required: false }
            },
            '3': {
                enterprise_id: { required: true },
                academy_id: { value: '', required: false }
            },
            '6': {
                enterprise_id: { required: false },
                academy_id: { value: '', required: false }
            }
        };
    
        const updates = fieldUpdatesByIndex[index] || {};
        
        const updatedInputs = {
            ...Inputs,
            ...Object.fromEntries(
                Object.entries(updates).map(
                    ([fieldKey, config]) => [fieldKey, getUpdatedField(fieldKey, config)]
                )
            )
        };
    
        onUpdateState('Inputs', updatedInputs);
    };
    
    render = () => {
        let props = this.props;

        let { onInputChange, onCloseAlert, onSubmit, onDiscardSubmit, onPreviewFile, onDeleteFile } = props;

        let { App, Action, Inputs, InputGroup, Masterbase, Operation, UserCookie } = props;

        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;

        let isLoading = Action.Loading.submit;

        return (
                <Offcanvas 
                    show={show}
                    placement="end" 
                    style={{ '--bs-offcanvas-width':  window.innerWidth < 768 ? '80vw' : '50vw' }}
                    scroll={true}
                    backdrop={Submit ? "static" : true}
                    onHide={(e) => props.onClose(e)}
                >
                    <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                        <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                    </Offcanvas.Header>

                    <Offcanvas.Body className="custom-offcanvas-body">
                        
                        <CommonAlert 
                            alert={Action.Alert} 
                            callback={(e) => onCloseAlert(e)}
                        />
                        
                        <SimpleBar id="inputs" className="simple-bar-input">

                                {/** 
                                <Card bg="light">
                                    <Card.Body>
                                */}
                                <Row>
                                    <Col md={6}>
                                        <CommonSelect
                                            element="Inputs"
                                            input={Inputs.types}
                                            option={{source: 'options', section: 'category', item: 'users'}}
                                            hr={false}
                                            callback={async (e, element) => { 
                                                await onInputChange(e, element);
                                                this.toggleUserTypes(e.target.value);
                                            }} 
                                            disabled={!['0', '1'].includes(UserCookie.types)}
                                        />
                                    </Col>
                                    {['2'].includes(Inputs.types.value) && (
                                        <Col md={6}>
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.subtypes}
                                                option={{source: 'db', data: Masterbase?.permission_name?.filter(i => i.types === Inputs.types.value) || []}} // check filter 
                                                hr={false}
                                                callback={async (e, element) => { 
                                                    await onInputChange(e, element);
                                                    this.toggleUserTypes(e.target.value);
                                                }} 
                                                disabled={!['0', '1'].includes(UserCookie.types)}
                                            />
                                        </Col>
                                    )}
                                </Row>

                                {['2', '3'].includes(Inputs.types.value) && (
                                    <Row className="mt-3"> 
                                        <Col md={12}>
                                            {Inputs.types.value === '2' && (
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.academy_id}
                                                    option={{source: 'db', data: Masterbase?.academy}}
                                                    hr={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={!['0', '1'].includes(UserCookie.types)}
                                                />
                                            )}
                                            {Inputs.types.value === '3' && (
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.enterprise_id}
                                                    option={{source: 'db', data: Masterbase?.enterprise}}
                                                    hr={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={!['0', '1', '5'].includes(UserCookie.types)}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                )}

                                <Row className="mt-3">
                                    <Col md={12}>
                                        <CommonInput
                                            element="Inputs"
                                            input={Inputs.fullname}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)} 
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col md={12}>
                                        <CommonInput
                                            element="Inputs"
                                            input={Inputs.position}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)} 
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col md={6}>
                                        <CommonInput
                                            element="Inputs"
                                            input={Inputs.email}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)} 
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <CommonInput
                                            element="Inputs"
                                            input={Inputs.contact}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)} 
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={12}><hr className="hr-custom" /></Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <CommonInput
                                            element="Inputs"
                                            input={Inputs.username}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)} 
                                            disabled={Action.Mode === 'new' ? false : true}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col md={6}>
                                        <CommonInput
                                            mode={Action.Mode}
                                            element="Inputs"
                                            input={Inputs.password}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)} 
                                            disabled={Action.Mode === 'new' ? false : true}
                                            
                                            onGeneratePassword={(e, element) => onInputChange({target: {name: 'password', value: util.generatePassword()}}, element)}

                                            toggleChangePassword={(e) => this.toggleChangePassword()}
                                        />
                                    </Col>
                                </Row>

                                {this.state.changePassword && (
                                    <Row className="mt-3">
                                        <Col md={6}>
                                            <CommonInput
                                                mode="new"
                                                element="Inputs"
                                                input={Inputs.new_password}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                                disabled={false}
                                                
                                                onGeneratePassword={(e, element) => onInputChange({target: {name: 'new_password', value: util.generatePassword()}}, element)}
                                            />
                                        </Col>
                                    </Row>
                                )}

                                <Row className="mt-3">
                                    <Col md={12}>
                                        <CommonFile
                                            element="Inputs"
                                            input={Inputs.profile_img}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)} 

                                            previewFile={(e) => onPreviewFile(e)} 
                                            deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                        />
                                    </Col>
                                </Row> 
                                {['0', '1'].includes(UserCookie.types) && (
                                    <Row className="mt-3">
                                        <Col md={6}>
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.status}
                                                option={{source: 'options', section: 'status', item: 'users'}}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row> 
                                )}
                            {/** 
                                </Card.Body>
                            </Card>
                            */}

                        </SimpleBar>

                    </Offcanvas.Body>
                    
                    <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">
                        
                        <CommonLoadingBar isLoading={isLoading} />

                        <div className="d-flex justify-content-end mt-2">
                            <CommonButton 
                                task={mode} 
                                disabled={isLoading ? true : Submit ? false : true}
                                callback={async (e) => { 
                                    await onSubmit(e);
                                    
                                    if(Action.Mode === 'update'){ await this.prepareInputs(); }
                                }} 
                            />

                            {Action.Mode === 'new' && (
                                <CommonButton 
                                    task="discard" 
                                    inlineClass="ms-1" 
                                    disabled={isLoading} 
                                    callback={(e) => onDiscardSubmit(false)} 
                                />
                            )}
                        </div>
                    </div>
                </Offcanvas>      
        )
    }
}

export default InputUserDataUser;